import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import properties from '../../constants/Properties';
import videoUtils from '../utils/VideoUtils';
import storeManager from '../../store/StoreManager';
import { updateControlPoint } from '../../actions/MenuActions';
import hoverManager from '../utils/HoverManager';
import saveManager from "../utils/SaveManager";
import locales from "../../locales/LocalesManager";

const ControlPointContent = React.createClass({
    getInitialState () {
        return {
            thumbSize: 26,
            isThumbOver: false,
            isThumbActive: false
        }
    },
    onThumbMouseIn () {
        if (this.props.index == 0)
            hoverManager.show(this.refs.videoControlPoint, 'videoLeftTrim');
        else
            hoverManager.show(this.refs.videoControlPoint, 'videoRightTrim', 'bottom');

        this.setState({
            isThumbOver: true
        });
    },
    onThumbMouseOut () {
        hoverManager.hide();

        this.setState({
            isThumbOver: false
        });
    },
    getPosition(position) {
        return Number(position.substring(0, position.length - 2));
    },
    onMouseDown(isKeyboard = false) {
        var left = this.getPosition(this.refs.thumb.style.left);

        if (isKeyboard) {
            this.setState({
                startPosition: left,
                isThumbActive: false
            });
        } else {
            this.setState({
                startPosition: left,
                isThumbActive: true
            });
        }
    },
    onMouseMove(e, coreEvent, movement) {
        if (movement)
            this.checkPosition(movement);
        else
            this.checkPosition(coreEvent.lastX);

        this.updateVideoControlPoint();
    },
    onMouseUp(e, coreEvent) {
        this.checkPosition(coreEvent.lastX);

        this.setState({
            isThumbActive: false
        });

        this.updateVideoControlPoint();
    },
    onKeyDown(e) {
        var delta = 5;

        if (e.keyCode == 37) { // Left Key
            this.onMouseDown(true);
            setTimeout(function() {
                this.onMouseMove(undefined, undefined, - delta);
            }.bind(this), 10);
        } else
        if (e.keyCode == 39) { // Right Key
            this.onMouseDown(true);
            setTimeout(function() {
                this.onMouseMove(undefined, undefined, delta);
            }.bind(this), 10);
        }
    },
    updateVideoControlPoint() {
        if (this.props.index == 1)
            videoUtils.updateStartPoint(true);
        else
            videoUtils.updateStartPoint();
    },
    checkPosition(deltaX) {
        var newPosition = (this.state.startPosition +  deltaX);

        if (newPosition < 0)
            newPosition = 0;

        if (newPosition > this.props.trackWidth)
            newPosition = this.props.trackWidth;

        var offSet = videoUtils.trackOffset();

        if (this.props.index == 0) { // is left marker
            if (videoUtils.rightMarkerPosition - newPosition < offSet)
                newPosition = videoUtils.rightMarkerPosition - offSet;

            videoUtils.leftMarkerPosition = newPosition;
        } else {
            if (newPosition - videoUtils.leftMarkerPosition < offSet)
                newPosition = videoUtils.leftMarkerPosition + offSet;

            videoUtils.rightMarkerPosition = newPosition;
        }

        this.forceUpdate();
        this.props.dispatch(updateControlPoint(Math.random()));

        this.refs.thumb.style.left = newPosition + 'px';

        videoUtils.markerPosition = videoUtils.leftMarkerPosition;

        var marker = document.getElementById('marker');
        marker.style.left = videoUtils.markerPosition + 'px';
        saveManager.isContentChanged(true);
    },
    getText() {
        var time;

        if (this.props.index == 0)
            time = videoUtils.getRealTimeInSeconds(videoUtils.leftMarkerPosition);
        else
            time = videoUtils.getRealTimeInSeconds(videoUtils.rightMarkerPosition);

        return videoUtils.convertTimeToStringFormat(time);
    },
    getLeftPosition() {
        if (this.props.index == 0)
            return videoUtils.leftMarkerPosition;
        else
            return videoUtils.rightMarkerPosition;
    },
    render() {
        const lineOffset = 12;
        const thumbSize = this.state.thumbSize;
        const lineWidth = 2;
        const lineHeight = this.props.trackHeight + lineOffset;
        var topPosition = -1 * (lineOffset + thumbSize / 2);
        var topLinePosition = thumbSize / 2;
        var topThumbPosition = - thumbSize / 2;

        if (this.props.index == 1) {
            topPosition = 0;
            topThumbPosition = lineHeight;
            topLinePosition = 0;
        }

        const buttonStyle = {
            position: 'absolute',
            top: topPosition,
            left: this.getLeftPosition()
        };

        var borderColor = 'white';
        var borderWidth = 2;

        if (this.state.isThumbOver || this.state.isThumbActive)
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        const thumbStyle = {
            position: 'absolute',
            left: - thumbSize / 2 - borderWidth,
            top: topThumbPosition,
            width: thumbSize,
            height: thumbSize,
            background: borderColor,
            borderRadius: 50,
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            borderColor: borderColor,
            borderWidth: borderWidth,
            borderStyle: 'solid',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const lineStyle = {
            position: 'absolute',
            left: - lineWidth / 2,
            top: topLinePosition,
            width: lineWidth,
            height: lineHeight,
            background: borderColor,
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none'
        };

        var idName = 'leftVideoControlPoint';
        var textCenter = 'left';
        var textWidth = 95;
        var textPos = - (thumbSize / 2 + textWidth);
        var textTopPos = -9;

        if (this.props.index == 1) {
            idName = 'rightVideoControlPoint';
            textCenter = 'right';
            textPos = thumbSize / 2;
            textTopPos = lineHeight + thumbSize / 2 - 9;
        }

        var textValue = this.getText();

        const textStyle = {
            position: 'absolute',
            top: textTopPos,
            left: textPos,
            color: 'white',
            fontSize: 19,
            width: textWidth,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            textAlign: textCenter
        };

        var ariaLabel;

        if (this.props.index == 0)
            ariaLabel = locales.getCaption('videoLeftTrim', 'hover');
        else
            ariaLabel = locales.getCaption('videoRightTrim', 'hover')

        return (
            <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                <div ref='thumb' id={idName} style={buttonStyle}>
                    <div style={lineStyle}/>
                    <button aria-label={ariaLabel} ref='videoControlPoint' style={thumbStyle} onKeyDown={this.onKeyDown} onMouseOver={this.onThumbMouseIn} onMouseOut={this.onThumbMouseOut}/>
                    <span style={textStyle}>{textValue}</span>
                </div>
            </Draggable>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const updateValue = state.menu.updateValue;

    return {
        updateValue
    };
}

export const ControlPoint = connect(mapStateToProps)(ControlPointContent);



/** WEBPACK FOOTER **
 ** ./src/components/videoEditor/ControlPoint.js
 **/